import React from "react";
import { Delete } from "lucide-react";

/**
 * Custom on-screen numeric keypad to avoid the OS keyboard popping up over the screen.
 * Behaves as a controlled component editing a money string ("0.00").
 */
export default function NumPad({ value, onChange, onDone, doneLabel = "Done", testIdPrefix = "keypad" }) {
  const set = (v) => onChange(v);

  const press = (k) => {
    let v = String(value ?? "");
    if (k === "back") {
      v = v.length > 1 ? v.slice(0, -1) : "0";
    } else if (k === ".") {
      if (!v.includes(".")) v = v + ".";
    } else if (k === "clear") {
      v = "0";
    } else {
      if (v === "0") v = k;
      else v = v + k;
    }
    // limit two decimals
    if (v.includes(".")) {
      const [a, b] = v.split(".");
      v = a + "." + (b || "").slice(0, 2);
    }
    set(v);
  };

  const keys = ["1","2","3","4","5","6","7","8","9","clear","0","."];
  return (
    <div data-testid="numpad" className="grid grid-cols-3 gap-3 select-none">
      {keys.map((k) => (
        <button
          key={k}
          data-testid={`${testIdPrefix}-${k}`}
          onClick={() => press(k)}
          className="h-14 rounded-xl bg-white border border-[#E8E4DA] text-2xl text-[#0D311E] shadow-sm active:bg-[#F5F2EA] active:scale-[0.98] transition-all"
          style={{ fontFamily: "'Fraunces', serif" }}
        >
          {k === "clear" ? "C" : k}
        </button>
      ))}
      <button
        data-testid={`${testIdPrefix}-back`}
        onClick={() => press("back")}
        className="h-14 rounded-xl bg-[#F5F2EA] border border-[#E8E4DA] flex items-center justify-center active:scale-[0.98]"
      >
        <Delete size={20} className="text-[#2B533E]" />
      </button>
      <button
        data-testid={`${testIdPrefix}-done`}
        onClick={onDone}
        className="col-span-2 h-14 rounded-xl bg-[#1A5D3A] text-white text-base font-medium active:bg-[#13462A] active:scale-[0.98] shadow-sm"
      >
        {doneLabel}
      </button>
    </div>
  );
}
